import { render, staticRenderFns } from "./DashboardItemSorter.vue?vue&type=template&id=7a29065c&"
import script from "./DashboardItemSorter.vue?vue&type=script&lang=js&"
export * from "./DashboardItemSorter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports